<template>
  <div class="r-table">
    <table class="r-table table table-striped">
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.field" scope="col">
            <span
              style="cursor: pointer"
              v-if="column.sortable"
              @click="handelSort(column.field)"
            >
              {{column.name}} <i class="fas fa-arrows-alt-v"></i>
            </span>
            <span v-else>{{column.name}}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <table-cell
            v-for="column in columns" :key="column.name"
            :id="item.id"
            :body="item[column.field]"
            :options="column.options"
            @cellClicked="handleCellClick(column.field, item)"
            @cellChecked="handleCellChecked(column.field, item)"
          />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import TableCell from './TableCell';

  export default {
    props: {
      /**
       * Array of columns
       * [
       *    {
       *        name: 'Example name' -> table column name
       *        field: 'title' -> item key
       *        options: {
       *           type: 'button', -> for now only button
       *           body: 'Accept user', -> button body
       *           showOnValue: true, -> show button when item value is equal this value
       *           placeholder: '' -> replace item value when showOnValue is not equal his value
       *         },
       *    }
       * ]
       */
      columns: {
        type: Array,
        required: true
      },
      /**
       * Array of items
       * [
       *      {
       *          id: 1 // can be item index
       *          title: 'key is the same as column field'
       *      }
       * ]
       */
      items: {
        type: Array,
        required: true
      }
    },

    methods: {
      handelSort(field) {
        this.$emit('onSort', field);
      },
      handleCellClick(field, item) {
        this.$emit('onItemClick', {
          field,
          item
        });
      },
      handleCellChecked(field, item) {
        this.$emit('onItemChecked', {
          field,
          item
        });
      }
    },

    components: {
      'table-cell': TableCell,
    }
  };
</script>

<style lang="scss">
  .r-table {
    tbody span {
      font-weight: 100;
    }
  }
</style>
